import { createTheme, alpha, lighten, darken } from "@mui/material/styles";

export const SIMPLColors = {
  Secondary: "#6ABBCC",
  Primary: "#4C6085",
  Light: "#F9F4F5",
  Red: "#C00000",
  Green: "#6BC584"
};

// These will only apply to MUI components, so we will
// want to use them as extensively as possible.
// We will want to continue expanding this theme as
// designs dictate our direction.
export const theme = createTheme({
  typography: {
    fontFamily: ["Roboto", "sans-serif"].join(","),
    h1: {
      fontSize: "4rem"
    },
    button: {
      textTransform: "none",
      // The submit button was at 20px in the mock, but I think it looks overly large in practice
      fontSize: "1rem"
    }
  },
  palette: {
    primary: {
      main: SIMPLColors.Primary,
      contrastText: "#fff"
    },
    secondary: {
      main: SIMPLColors.Secondary
    },
    light: {
      main: SIMPLColors.Light
    },
    error: {
      main: SIMPLColors.Red
    },
    success: {
      main: SIMPLColors.Green
    }
  },
  components: {
    MuiGrid2: {
      defaultProps: {
        columns: 12,
        columnSpacing: 2,  // 16px
        rowSpacing: 2      // 16px
      }
    }
  }
});

// Extend theme to include utility functions for backward compatibility
// Some MUI components (like TableRow, TableCell) expect these functions to exist on theme
(theme as any).alpha = alpha;
(theme as any).lighten = lighten;
(theme as any).darken = darken;
